module.exports = ".fa-edit {\n  cursor: pointer;\n}\n.img-profile {\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.img-hover {\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  text-align: center;\n}\n.img-container:hover .img-hover {\n  opacity: 1;\n}\n.img-container:hover .img-profile {\n  opacity: 0.3;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.css
// module id = ./src/app/profile/profile.component.css
// module chunks = main